import React from 'react'
import { Link } from 'gatsby'

import Section from '../Section'
import xealGradient from 'src/images/logos/xealGradient.svg'
import footerHelix from 'src/images/footer_helix_2.svg'

import * as styles from './footer.module.scss'

import {
  solutions,
  company,
  login,
  salesAndSupport,
  socials,
} from 'src/components/globals/footerLinks.js'
import classNames from 'classnames'

export default function Footer() {
  const year = new Date()?.getFullYear()

  return (
    <footer className={styles.footer}>
      <Section>
        <div className="full-width">
          <div className={styles.container}>
            <div className={styles.logoWrap}>
              <Link to="/">
                <img
                  src={xealGradient}
                  alt="xeal logo"
                  width="120"
                  height="54"
                />
              </Link>

              <div className={styles.salesAndSupport}>
                <h5>Sales & Support</h5>
                <a
                  href={salesAndSupport.phone.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {salesAndSupport.phone.text}
                </a>
                <a
                  href={salesAndSupport.email.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {salesAndSupport.email.text}
                </a>
              </div>

              <div className={styles.socials}>
                <a
                  href={socials.linkedIn.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={socials.linkedIn.icon}
                    alt="linkedIn"
                    width="24"
                    height="24"
                  />
                </a>
                <a
                  href={socials.instagram.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={socials.instagram.icon}
                    alt="instagram"
                    width="24"
                    height="24"
                  />
                </a>
                <a href={socials.twitter.href} target="_blank" rel="noreferrer">
                  <img
                    src={socials.twitter.icon}
                    alt="x"
                    width="24"
                    height="24"
                  />
                </a>
              </div>

              <div className={styles.cc}>© {year} Xeal</div>
            </div>

            <nav className={styles.footerNav}>
              <NavColumn name="Solutions" links={solutions} />
              <NavColumn name="Company" links={company} />
              <NavColumn name="Login" links={login} />
            </nav>
          </div>
        </div>
      </Section>

      <img className={styles.footerHelix} src={footerHelix} alt="xeal helix" />
    </footer>
  )
}

const NavColumn = ({ links, name }) => {
  return (
    <div className={classNames(styles.footerColumn, styles[name])}>
      <h5 className={styles.footerColHeader}>{name}</h5>
      <ul>
        {links.map((item) => (
          <li key={item.text}>
            <LinkBuilder {...item} />
          </li>
        ))}
      </ul>
    </div>
  )
}

const LinkBuilder = ({ text, to, href }) => {
  if (href) {
    return (
      <a href={href} target="_blank" rel="noreferrer">
        {text}
      </a>
    )
  }

  if (to) {
    return <Link to={to}>{text}</Link>
  }

  return <p style={{ color: 'red' }}>missing href / to</p>
}
